/** @flow */

import type { SystemAccessState } from "./types";

export const initialState: SystemAccessState = {
  requestsInProgress: 0,
  generalSettings: {
    selfServiceEnabled: null,
    isLocked: null,
    enableResetPasswordRequirement: null,
    passwordResetFrequencyManager: null,
    passwordResetFrequencyEmployee: null,
    inactiveTimeout: null,
    failedLoginLockout: null,
    ipRestrictionEnabled: null,
    ipRestrictionWhitelist: null,
    multiFactorAuthenticationEnabled: false,
  },
  modals: {
    showAddIpRestrictionModal: false,
    showLogoModal: false,
    showPasswordResetModal: false,
    showLogOutLockModal: false,
    showClientLogoModal: false,
    showBulkRegistrationEmailsModal: false,
    showStandardRegistrationEmailsModal: false,
    showBulkRegistrationEmailsExportModal: false,
    showEmployeeRegistrationEmailsModal: false,
    confirmEnableMFA: false,
  },
  bulkRegistrationEmailTargets: 0,
  employeeRegistrationEmailTargets: 0,
  registrationEmails: null,
  schema: null,
  logoUrl: null,
  passwordPolicy: null,
  emails: {
    content: [],
    pagination: {
      sort: { orders: [] },
      pageNumber: 0,
      pageSize: 0,
      offset: 0,
    },
    totalElements: 0,
  },
};

export default initialState;
